<template>
  <div class="full">
    <md-card>
      <md-card-header>
        <md-whiteframe md-tag="md-toolbar" md-elevation="2" class="md-medium">
          
          <div class="md-toolbar-container">
            <h2 class="md-title">Adicionar Solicitações</h2>
            <router-link to="/">
              <md-button class="md-fab md-fab-cancel">
                <md-icon>clear</md-icon>
                <md-tooltip md-direction="top">Cancelar</md-tooltip>
              </md-button>
            </router-link>

            <md-button @click="openSaveDialog" id="save" class="md-fab md-fab-save">
              <md-icon>done</md-icon>
              <md-tooltip md-direction="top">Salvar</md-tooltip>
            </md-button>
          </div>

          <div class="md-toolbar-container">
            <h2 class="md-subheading sub-head"> {{formattedSummary}} </h2>
          </div>
        </md-whiteframe>
      </md-card-header>

      <md-card-content class="scrolable">

        <md-layout md-gutter>
          <md-layout md-gutter md-flex="100">
            <md-input-container :class="{ 'md-input-invalid' : ticketsInfo.hasTicketTypeError && !ticketsInfo.ticketType}">
                <label for="reason">Motivo</label>
                <md-select required v-model="ticketsInfo.ticketType" id="reason" @selected="findQuestionsByType">
                  <md-option v-for="(name, ticketType) in ticketTypes" 
                            :key="ticketType" :value="ticketType"> 
                              {{name}} 
                  </md-option>
                </md-select>
              </md-input-container>
          </md-layout>
        </md-layout>

        <md-layout md-gutter="16" v-for="(vehicleTicket, i) in ticketsInfo.vehicleTickets" :key="i">
          <md-layout md-flex>
            <md-input-container>
              <label>Placa</label>
              <md-autocomplete required v-model="vehicleTicket.plate"
                                :fetch="findVehiclesByPlateFetch"
                                :print-attribute="'plate'"
                                @selected="isPlatesInTickets">
              </md-autocomplete>
              <span class="md-error">{{vehicleTicket.messageError}}</span>
            </md-input-container>
          </md-layout>

          <md-layout md-flex>
            <md-input-container>
              <label>Organização</label>
              <md-autocomplete required v-model="vehicleTicket.organization.name"
                                :fetch="findOrganizationByNameFetch"
                                :print-attribute="'name'">
              </md-autocomplete>
            </md-input-container>
          </md-layout>

          <md-layout md-flex="10" v-if="isRequesting === true">
            <md-spinner class="align-to-field" :md-size="20" md-indeterminate></md-spinner>
          </md-layout>

          <md-layout md-flex="10" v-if="ticketsInfo.vehicleTickets.length !== 1">
            <md-button @click="removeVehicle(vehicleTicket)" class="md-icon-button md-warn align-to-field">
              <md-icon>cancel</md-icon>
            </md-button>
          </md-layout>
        </md-layout>

        <md-layout md-gutter v-if="ticketsInfo.ticketType === 'INSTALL_UNINSTALL'">
          <md-layout md-flex>
            <md-button class="md-raised md-primary" @click="addVehicle">Adicionar outro veículo</md-button>
          </md-layout>
        </md-layout>
        
        <md-layout md-gutter>
          <md-layout md-flex>
            <md-input-container :class="{ 'md-input-invalid' : ticketsInfo.hasDescriptionError && !ticketsInfo.description}">
              <label>Descrição</label>
              <md-textarea v-model="ticketsInfo.description" required></md-textarea>
            </md-input-container>
          </md-layout>
        </md-layout>

        <br/>

        <div v-if="adictionalQuestions.ticketType">
          <h2 class="md-subheading">Informações Adicionais</h2>

          <div v-if="ticketsInfo.lastCoordinate.lastTransmissionTime !== null && ticketsInfo.ticketType === 'TRANSMISSION_FAIL'">
            <br/>
            <span class="md-body-1">Última transmissão à {{ticketsInfo.lastCoordinate.lastTransmissionTime}} horas</span>
          </div>

          <md-table v-show="hasBooleanQuestion()">
            <md-table-header>
              <md-table-row>
                <md-table-head></md-table-head>
                <md-table-head>Sim</md-table-head>
                <md-table-head>Não</md-table-head>
              </md-table-row>
            </md-table-header>

            <md-table-body>
              <md-table-row v-for="(field, i) in getFieldsByType(adictionalQuestions.fields, 'BOOLEAN')" :key="i">
                <md-table-cell>
                  {{field.name}}
                </md-table-cell>

                <md-table-cell> 
                  <input type="radio" :name="'g_'+i" v-model="ticketsInfo.questionsResponses[field.name]" :value="true" :checked="ticketsInfo.questionsResponses[field.name] == true" @change="isWrongResponse(field)">
                </md-table-cell>
                
                <md-table-cell> 
                  <input type="radio" :name="'g_'+i" v-model="ticketsInfo.questionsResponses[field.name]" :value="false" :checked="ticketsInfo.questionsResponses[field.name] == false" @change="isWrongResponse(field)">
                </md-table-cell>
              </md-table-row>
            </md-table-body>
          </md-table>

          <br/>

          <div v-if="hasStringQuestion()">
            <md-input-container v-for="(field, i) in getFieldsByType(adictionalQuestions.fields, 'STRING')" :key="i">
              <label>{{field.name}}</label>
              <md-input v-model="ticketsInfo.questionsResponses[field.name]"></md-input>
            </md-input-container>
          </div>

          <div v-if="hasFileQuestion()">
            <md-input-container v-for="(field, i) in getFieldsByType(adictionalQuestions.fields, 'FILE')" :key="i">
              <label>{{field.name}}</label>
              <md-file id='file' v-model="ticketsInfo.questionsResponses[field.name]" @selected="encodeFile($event, field.name)"></md-file>
            </md-input-container>
          </div>

        </div>
 
      </md-card-content>
    </md-card>

    <md-snackbar :md-position="snack.vertical + ' ' + snack.horizontal" ref="snackbar" :md-duration="snack.duration">
      <span class="md-warn">{{snack.message}}</span>
      <md-button class="md-accent" @click="$refs.snackbar.close()">Ok</md-button>
    </md-snackbar>

    <md-dialog md-open-from="#wait" md-close-to="#wait" ref="wait">
      <md-dialog-title>Aguarde ...</md-dialog-title>

      <md-dialog-content>
        <md-progress md-indeterminate></md-progress>
      </md-dialog-content>
    </md-dialog>

    <md-dialog md-open-from="#save" md-close-to="#save" ref="save">
      <md-dialog-title>Tem certeza que deseja salvar estes tickets?</md-dialog-title>

      <md-dialog-content></md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="closeSaveDialog()">Não</md-button>
        <md-button class="md-primary" @click="saveTickets()">Sim</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
  import Vue from 'vue'
  import ticketsService from '../services/TicketsService'
  import { version } from 'moment';

  export default {
    created() {
      this.findCustomerName();
    },

    data() {
      return {
        customerName : null,
        ticketsInfo: {
          created : null,
          description : null,
          ticketType : null,
          vehicleTickets: [
            {serial: null, plate: null, organization: {name: null}}
          ],
          questionsResponses: {},
          lastCoordinate: {
            coordinateDate: null,
            lastTransmissionTime: null
          },
        },

        adictionalQuestions: {
          ticketType: null,
          fields: null
        },

        ticketTypes : {
          "INSTALL_UNINSTALL" : "(Des)instalação/Remanejamento",
          "EQUIPMENT_FAIL" : "Falha no equipamento",
          "TRANSMISSION_FAIL" : "Falha de transmissão",
          "RFID" : "Falha no leitor RFID",
          "SYSTEM_REGISTER" : "Cadastros no sistema",
          "GENERAL_DOUBT" : "Dúvida Geral",
          "OTHERS" : "Outros"
        },

        snack:{
          vertical: 'bottom',
          horizontal: 'center',
          duration: Infinity,
          message: null
        },
        isRequesting: false
      };
    },

    methods: {
      saveTickets : function () {
        var isValid = this.validateTickets();
        this.closeSaveDialog();
        if(isValid === true){
          this.openWaitDialog();
          ticketsService.createTickets(this.ticketsInfo).then((success) => {
            this.closeWaitDialog();
            location.reload();
          }, (failure) =>{
            this.closeWaitDialog();
            this.snack.message = failure.bodyText;
            this.openSnack();
          });
        }
      },

      hasBooleanQuestion() {
        var boolFields = this.getFieldsByType(this.adictionalQuestions.fields, 'BOOLEAN')
        return boolFields.length > 0;
      },

      hasStringQuestion() {
        var stringFields = this.getFieldsByType(this.adictionalQuestions.fields, 'STRING')
        return stringFields.length > 0;
      },

      hasFileQuestion() {
        var fileFields = this.getFieldsByType(this.adictionalQuestions.fields, 'FILE')
        return fileFields.length > 0;
      },

      findQuestionsByType(type) {
        ticketsService.findQuestionsByType(type).then((success) => {
          this.ticketsInfo.questionsResponses = {};

          if (success.body.fields) {
            success.body.fields.forEach((field, i, array) => {
              this.ticketsInfo.questionsResponses[field.name] = null;
            });
          }

          this.adictionalQuestions = success.body;
        })
      },

      isWrongResponse(field) {
        if (field.correctValue !== null && this.ticketsInfo.questionsResponses[field.name] !== null) {
          if (field.correctValue !== this.ticketsInfo.questionsResponses[field.name]) {
            this.snack.message = field.wrongValueMessage;
            this.openSnack();
          }
        }
      },

      findVehiclesByPlateFetch(query) {
        if(query.q && query.q !== "") {
          this.isRequesting = true
          return ticketsService.findVehiclesByPlate(query.q).then((success) => {
            this.isRequesting = false
            if (success.body.length === 1){
              this.isPlatesInTickets(success.body[0], success.body[0].plate)
              return [];
            }
            return success.body;
          });
        }
      },

      findOrganizationByNameFetch(query) {
        if(query.q && query.q !== "") {
          this.isRequesting = true;
          return ticketsService.searchOrganizations(query.q).then((success) => {
            this.isRequesting = true;
            return success.body;
          });
        }
      },

      getFieldsByType(fields, type) {
        if(fields) {
          return fields.filter(function(field, i, array) {
            return field.type === type;
          });
        }
        return [];
      },

      encodeFile(files, fieldName) {
        var reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = () => {
          this.ticketsInfo.questionsResponses[fieldName] = reader.result.split("base64,")[1];
        };
      },

      isPlatesInTickets : function (vehicle, plate) {
        this.ticketsInfo.vehicleTickets.forEach(vehicleTicket => {
          if(vehicleTicket.plate.toUpperCase() === plate.toUpperCase()){
            vehicleTicket.code = vehicle.code;
            vehicleTicket.equipment = vehicle.equipment;
            vehicleTicket.organization = vehicle.organization;
            vehicleTicket.hasPlateError = false;
            vehicleTicket.messageError = "";
          }
        });
        vehicle.hasPlateError = false;
        vehicle.messageError = "";
        this.findLastCoordinate(vehicle.id)
        ticketsService.isPlatesInTickets(plate).then((success) => {
          
        }, (error) => {
          this.ticketsInfo.vehicleTickets.forEach(vehicleTicket => {
            if(vehicleTicket.plate === plate){
              vehicleTicket.hasPlateError = true;
              vehicleTicket.messageError = error.bodyText;
            }
          });
          vehicle.hasPlateError = true;
          vehicle.messageError = error.bodyText;
          this.snack.message = error.bodyText;
          this.openSnack();
        });
      },

      findLastCoordinate(vehicleId) {
        ticketsService.findLastCoordinate(vehicleId).then((success) => {
          this.ticketsInfo.lastCoordinate = success.body;
        })
      },

      validateTickets : function () {
        if(!this.ticketsInfo.ticketType || this.ticketsInfo.ticketType === ''){
          this.ticketsInfo.hasTicketTypeError = true;
          this.snack.message = 'O campo motivo não pode ser vazio';
          this.openSnack();
          return false;
        }
        if(!this.ticketsInfo.description || this.ticketsInfo.description === ''){
          this.ticketsInfo.hasDescriptionError = true;
          this.snack.message = 'O campo descrição não pode ser vazio';
          this.openSnack();
          return false;
        }
        if(this.ticketsInfo.vehicleTickets.length === 0 || 
            !this.ticketsInfo.vehicleTickets[0].plate || 
            this.ticketsInfo.vehicleTickets[0].plate === ''){
          this.snack.message = 'Selecione ao menos um veículo';
          this.openSnack();
          return false;
        }
        
        if(this.adictionalQuestions.fields) {
          if(this.ticketsInfo.ticketType === 'TRANSMISSION_FAIL') {
            if (this.ticketsInfo.lastCoordinate.lastTransmissionTime !== null && this.ticketsInfo.lastCoordinate.lastTransmissionTime < 36){
              this.snack.message = 'O veículo selecionado transmitiu nas últimas 36 horas';
              this.openSnack();
              return false;
            }
          }

          var i;
          for (i in this.adictionalQuestions.fields) {
            var field = this.adictionalQuestions.fields[i];
            if(this.ticketsInfo.questionsResponses[field.name] === null){
              this.snack.message = 'Todas as informações adicionais devem ser respondidas';
              this.openSnack();
              return false;
            }
          }
        }
        
        var i;
        for(i in this.ticketsInfo.vehicleTickets){
          if(this.ticketsInfo.vehicleTickets[i].hasPlateError === true){
            this.snack.message = 'Remova as placas que já possuem Tickets abertos';
            this.openSnack();
            return false;
          }
          if(!this.ticketsInfo.vehicleTickets[i].plate || this.ticketsInfo.vehicleTickets[i].plate === ''){
            this.ticketsInfo.vehicleTickets[i].hasPlateError = true;
            this.snack.message = 'Selecione um veículo ou remova o ticket';
            this.openSnack();
            return false;
          }
          if(!this.ticketsInfo.vehicleTickets[i].organization.name || this.ticketsInfo.vehicleTickets[i].organization.name === ''){
            this.ticketsInfo.vehicleTickets[i].hasOrganizationError = true;
            this.snack.message = 'Selecione uma organização para cada placa';
            this.openSnack();
            return false;
          }
        }
        return true;
      },

      findCustomerName : function() {
        ticketsService.findCustomerName().then((success) => {
          this.customerName = success.bodyText;
        })
      },

      openSnack : function() {
        this.$refs.snackbar.open();
      },

      closeSnack : function() {
        this.$refs.snackbar.close();
      },

      addVehicle : function () {
        this.ticketsInfo.vehicleTickets.push({plate: null, organization: {name: null}});
      },

      removeVehicle : function(vehicleTicket){
        var i = this.ticketsInfo.vehicleTickets.indexOf(vehicleTicket);
        this.ticketsInfo.vehicleTickets.splice(i, 1);
      },

      openWaitDialog : function() {
        this.$refs.wait.open();
      },

      closeWaitDialog : function() {
        this.$refs.wait.close();
      },

      openSaveDialog : function(){
        this.$refs.save.open();
      },

      closeSaveDialog : function(){
        this.$refs.save.close();
      }

    },

    computed: {
      formattedSummary : function() {
        var summary = this.customerName ? this.customerName.toUpperCase() : '';
        var vehiclesLen = this.ticketsInfo.vehicleTickets.length;
        
        if (vehiclesLen == 0) {
          summary += " - Nenhum veículo - Nenhuma organização"
        }else if (vehiclesLen == 1){
          var organizationName = this.ticketsInfo.vehicleTickets[0].organization.name;
          var plate = this.ticketsInfo.vehicleTickets[0].plate;

          organizationName = organizationName ? organizationName.toUpperCase() : null;
          plate = plate ? plate.toUpperCase() : null;
          if (plate && organizationName) {
            summary += " - " + organizationName + " - " + plate;
          } else if (organizationName) {
            summary += " - " + organizationName;
          } else if (plate) {
            summary += " - " + plate;
          }
          
        } else {
          summary += " - " + vehiclesLen + " Organizações - " + vehiclesLen + " Veículos"
        }

        return summary;
      },

    }
    
  };
</script>

<style>
  .md-fab-save {
    margin: 0;
    position: absolute !important;
    bottom: -28px;
    right: 26px;
  }

  .md-fab-cancel {
    margin: 0;
    position: absolute !important;
    bottom: -28px;
    right: 90px;
  }

  .scrolable{
    position: relative;
    max-height: 400px;
    overflow-y: scroll;
  }

  .wrap {
    width: 100%;
  }

  .wrap table {
    width: 100px;
    table-layout: fixed;
  }

  .align-to-field{
    margin-top: 15px !important;
  }

  .sub-head{
    margin-left: 8px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/CreateTicketsV2.vue